import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { QAPart, SPCResponse } from "@shared/types";

export function useQAParts() {
  return useQuery({
    queryKey: ["quality", "parts"],
    queryFn: () => apiFetch<QAPart[]>("/api/quality/products"),
    staleTime: 10 * 60 * 1000,
  });
}

export function useSPCData(
  product: string,
  test: string,
  from: string,
  to: string,
  filters?: {
    operator?: string;
    shift?: string;
  }
) {
  return useQuery({
    queryKey: ["quality", "spc", product, test, from, to, filters],
    queryFn: () =>
      apiFetch<SPCResponse>("/api/quality/spc", {
        product,
        test,
        from,
        to,
        operator: filters?.operator,
        shift: filters?.shift,
      }),
    enabled: !!product,
  });
}

export function useSampleDetail(sampleId: number | null, product: string) {
  return useQuery({
    queryKey: ["quality", "sample", sampleId, product],
    queryFn: () =>
      apiFetch<Record<string, unknown>>(`/api/quality/sample/${sampleId}`, { product }),
    enabled: !!sampleId && !!product,
    staleTime: 5 * 60 * 1000,
  });
}
